import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function visitorId() {
  let v = localStorage.getItem("atlas-visitor");
  if (!v) {
    v = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    localStorage.setItem("atlas-visitor", v);
  }
  return v;
}

const headers = () => ({ "X-Atlas-Visitor": visitorId() });

export async function generateRoute(destination) {
  const { data } = await axios.post(
    `${API}/route/generate`,
    { destination },
    { headers: headers() }
  );
  return data;
}

export async function getQuota() {
  const { data } = await axios.get(`${API}/route/quota`, { headers: headers() });
  return data;
}
